<template>
  <ly-avatar :record="getParams.fieldValue" :sourceType="getParams.sourceType" :size="22"></ly-avatar>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});
const getParams = computed(() => props.params);
</script>
<style scoped lang="less">
@import './avatar.less';
</style>
